
import { defineComponent, PropType, ref, getCurrentInstance } from 'vue';
import { isTest } from '@/common/env';

export interface ActionItem {
    type: 'report' | 'login' | 'custom';
    payload?: any;
    label?: string;
    onClick?: () => void;
}

export default defineComponent({
    name: 'ActionPopover',
    props: {
        actions: {
            type: Array as PropType<ActionItem[]>,
            required: true,
        },
        overlayClassName: {
            type: String,
            default: '',
        },
        placement: {
            type: String,
            default: 'bottomRight',
        },
        showArrow: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const { proxy } = getCurrentInstance() as any;
        const isHovering = ref(false);
        const visible = ref(false);
        const getReportUrl = (source: number, linkId: string | number) => {
            // const baseUrl = 'https://www.kwai.com/content-report/home';
            const baseUrl = isTest
                ? 'https://czj-snack.test.gifshow.com/content-report/home'
                : 'https://www.kwai.com/content-report/home';
            return `${baseUrl}?violationSource=${source}&linkId=${linkId}`;
        };

        const handleAction = (action: ActionItem) => {
            isHovering.value = false; // 点击后取消 hover 状态
            visible.value = false; // 点击后关闭弹窗
            if (action.type === 'report') {
                const { source, linkId } = action.payload || {};
                if (!source || linkId === undefined || linkId === null) {
                    console.warn('Report action missing payload (source or linkId)');
                    return;
                }
                const url = getReportUrl(source, linkId);
                window.open(url, '_blank');
            } else if (action.onClick) {
                action.onClick();
            }
        };

        const getActionText = (action: ActionItem) => {
            if (action.label) return action.label;
            if (action.type === 'report') return proxy.$root.$t('report_button');
            return '';
        };

        return {
            handleAction,
            getActionText,
            isHovering,
            visible,
        };
    },
});
